import { render, staticRenderFns } from "./loan-balance.vue?vue&type=template&id=244fcb93&"
import script from "./loan-balance.vue?vue&type=script&lang=js&"
export * from "./loan-balance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports